import Vue from 'vue';
import Vuex from 'vuex';
import { standardMenus, authorityFun, idToItemDetail, pathToItemDetail, displayMenus } from '../libs/menus_util'
import modules from './modules'

Vue.use(Vuex);

const store_config = {
  state: {
    window_height: 800,
    window_width: 1024,
    cur_customer: {groups: []},
    // 小红点 {red_dot_token1: 99, red_dot_token1: 15, ...}
    red_dot_hash: {},
    menus: [],
    routersHash: {},
    menu_id_hash: {},
    menu_source: [],
    path_hash: {},
    hash_authority: {},
    click_menus:[],
    full_screen: false
    // leftWidth: 5,
  },
  getters: {
    // 是否为财务人员
    is_financer: (state) => {
      return state.cur_customer && state.cur_customer.groups.includes('GROUP_FIN');
    }
  },
  mutations: {
    setWindowHeight(state, height) {
      state.window_height = height;
    },
    setWindowWidth(state, width) {
      state.window_width = width;
    },
    setCurCustomer(state, customer) {
      state.cur_customer = customer
    },
    setRedDotHash(state, hash) {
      state.red_dot_hash = hash;
    },
    setFullScreen(state, full_screen) {
      state.full_screen = full_screen;
    },
    // 获取
    setAuthorityTree(state, { data, callBack }) {
      const [ menus ] = standardMenus(data)
      const hash_authority = authorityFun(menus)
      const menu_id_hash = idToItemDetail(menus)
      const path_hash = pathToItemDetail(menus)
      const click_menus = displayMenus(menus)
      state.menu_id_hash = menu_id_hash
      state.menus = menus
      state.click_menus = click_menus
      state.hash_authority = hash_authority
      state.menu_source = data
      state.path_hash = path_hash
      if (callBack) {
        callBack(hash_authority)
      }
    },
  },
  actions: {},
  modules: modules
};

const store = new Vuex.Store(store_config);

export default store;
